import { render } from "./AccountManageCreatePage.vue?vue&type=template&id=47627a78&lang=true"
import script from "./AccountManageCreatePage.vue?vue&type=script&lang=js"
export * from "./AccountManageCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__